import React from 'react';

import { ImagePlaceholder2 as PlaceholderIcon } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';

interface ImagePlaceholderProps {
  className?: string;
  onClick: () => void;
}

const ImagePlaceholder = ({ className, onClick }: ImagePlaceholderProps) => {
  return (
    <Stack
      alignItems="center"
      className={cn(
        'cursor-pointer overflow-hidden border border-dashed border-border-dark hover:border-text-placeholder',
        className,
      )}
      justifyContent="center"
      onClick={onClick}>
      <PlaceholderIcon className="h-44 w-44" />
    </Stack>
  );
};

export default ImagePlaceholder;
